import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {
  heading: 'heading',
  body_text: 'body_text',
};
export default {
  crawlType: 'icon_grid_row',
  matchTemplates: [
    {
      type: sectionType.sectionIconWithTextB1,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text],
      priority: 1,
    },
    {
      type: sectionType.sectionCardBadgeRivoneed,
      tags: [IDENTIFIER_TAGS.heading, IDENTIFIER_TAGS.body_text],
      priority: 2,
    },
  ],
};
